export const overrideOrValue = <V>(override: V | undefined, value: V): V =>
  override ?? value;
